/* cost_calculator.js – Condo Elects estimator */
document.addEventListener('turbolinks:load', () => {
  if (!document.getElementById('costCalculatorHeaderName')) return;

  /* ────────── PRICE TIERS ────────── */
  // Physical-mailing tiers reflect the $0.05/unit increase effective 2026-07-15
  // (electronic_notification/reminder/pre-ballot, nomination_form, ballot).
  // The email (electronic delivery) and inspector tiers are unchanged.
  const PRICE_TIERS = {
    electronic_notification_reminder_pre_ballot: [
      [0,  99, 3.30], [100,149,3.05],
      [150,299,2.80], [300,1000,2.30],
      [1001,Infinity,1.80]
    ],
    nomination_form: [
      [0,  99, 3.30], [100,149,3.05],
      [150,299,2.80], [300,1000,2.30],
      [1001,Infinity,2.05]
    ],
    ballot: [
      [0,  99, 4.80], [100,149,4.55],
      [150,299,4.30], [300,1000,3.80],
      [1001,Infinity,3.55]
    ],
    email: [
      [0,  99, 0.38], [100,149,0.35],
      [150,299,0.28], [300,Infinity,0.25]
    ],
    inspector: [
      [0,0,0], [1,20,350], [21,199,450], [200,Infinity,650]
    ]
  };

  const price = (tier, units) =>
    PRICE_TIERS[tier].find(([lo, hi]) => units >= lo && units <= hi)[2];

  const line = (tier, units, label) => {
    const rate = price(tier, units);
    return { label: `${label} @ $${rate.toFixed(2)}`, cost: rate * units };
  };

  const electronicAnnual = [
    u => line('email', u, 'Electronic Consent Notice (email)'),
    u => line('email', u, 'Nomination Form (email)'),
    u => line('email', u, 'Pre-Ballot Notification (email)'),
    u => line('email', u, 'Ballot (email)')
  ];

  const paperAnnual = [
    u => line('electronic_notification_reminder_pre_ballot', u, 'Electronic Notification (paper)'),
    u => line('nomination_form',                             u, 'Nomination Form (paper)'),
    u => line('electronic_notification_reminder_pre_ballot', u, 'Pre-Ballot Notification (paper)'),
    u => line('ballot',                                      u, 'Ballot (paper)')
  ];

  const TYPES = {
    annual:  { electronic: electronicAnnual, paper: paperAnnual,
               fee: units => price('inspector', units) },
    recall:  { electronic: electronicAnnual, paper: paperAnnual,
               fee: units => price('inspector', units) },
    acclamation: {
      electronic: [
        u => line('email', u, 'Electronic Notification (email)'),
        u => line('email', u, 'Nomination Form (email)'),
        u => line('email', u, 'Nomination Form Reminder (email)')
      ],
      paper: [
        u => line('electronic_notification_reminder_pre_ballot', u, 'Electronic Notification (paper)'),
        u => line('nomination_form',                             u, 'Nomination Form (paper)'),
        u => line('electronic_notification_reminder_pre_ballot', u, 'Nomination Form Reminder (paper)')
      ],
      fee: units => (units <= 20 ? 50 : 100)
    },
    change_docs: {
      electronic: [
        u => line('email', u, 'Electronic Notification (email)'),
        u => line('email', u, 'Pre-Ballot Notification (email)'),
        u => line('email', u, 'Ballot (email)')
      ],
      paper: [
        u => line('electronic_notification_reminder_pre_ballot', u, 'Electronic Notification (paper)'),
        u => line('electronic_notification_reminder_pre_ballot', u, 'Pre-Ballot Notification (paper)'),
        u => line('ballot',                                      u, 'Ballot (paper)')
      ],
      fee: units => price('inspector', units)
    },
    special_assessment: {
      electronic: [],
      paper: [
        u => line('electronic_notification_reminder_pre_ballot', u, 'Electronic Notification (paper)'),
        u => line('electronic_notification_reminder_pre_ballot', u, 'Pre-Ballot Notification (paper)'),
        u => line('ballot',                                      u, 'Ballot (paper)')
      ],
      fee: units => price('inspector', units)
    },
    other: {
      electronic: [
        u => line('email', u, 'Electronic Notification (email)'),
        u => line('email', u, 'Pre-Ballot Notification (email)'),
        u => line('email', u, 'Ballot (email)')
      ],
      paper: [
        u => line('electronic_notification_reminder_pre_ballot', u, 'Electronic Notification (paper)'),
        u => line('electronic_notification_reminder_pre_ballot', u, 'Pre-Ballot Notification (paper)'),
        u => line('ballot',                                      u, 'Ballot (paper)')
      ],
      fee: units => price('inspector', units)
    }
  };

  const elType         = document.getElementById('election-type');
  const elE            = document.getElementById('electronic');
  const elP            = document.getElementById('paper');
  const outT           = document.getElementById('total');
  const outB           = document.getElementById('breakdown');
  const assessmentNote = document.getElementById('assessment-note');
  const marketingNote  = document.getElementById('marketing-note');
  const noElectronic   = document.getElementById('no-electronic-note');

  const disableElectronicIfNeeded = () => {
    const special = elType.value === 'special_assessment';
    elE.disabled = special;
    if (special) elE.value = 0;
  };

  const showAssessmentNote = () => {
    const assessment = elType.value === 'special_assessment' || elType.value === 'other';
    assessmentNote.classList.toggle('hidden', !assessment);
  };

  const showMarketingNote = (eUnits, pUnits) => {
    const qualifies =
      pUnits === 0 && eUnits > 0 &&
      ['annual','recall','change_docs','other','acclamation'].includes(elType.value);
    marketingNote.classList.toggle('hidden', !qualifies);
  };

  const showNoElectronicNote = eUnits => {
    noElectronic.classList.toggle('hidden', eUnits > 0);
  };

  const recalc = () => {
    disableElectronicIfNeeded();
    showAssessmentNote();

    const eUnits = +elE.value || 0;
    const pUnits = +elP.value || 0;
    const cfg    = TYPES[elType.value];

    let lines = [];

    if (eUnits) cfg.electronic.forEach(f => lines.push(f(eUnits)));

    if (pUnits) cfg.paper.forEach(f => {
      const l = f(pUnits);
      const isElectronicNotice = l.label.startsWith('Electronic Notification');
      const isPreBallotNotice  = l.label.startsWith('Pre-Ballot Notification');
      const type = elType.value;
      // For annual/recall: ECF and Pre-Ballot are separate mailings — include both.
      // For other types (change_docs, other): Electronic Notification replaces
      // Pre-Ballot Notification when electronic units exist.
      // Without electronic units: skip Electronic Notification for all types.
      if (eUnits === 0 && isElectronicNotice) return;
      if (eUnits > 0  && isPreBallotNotice && type !== 'annual' && type !== 'recall') return;
      lines.push(l);
    });

    let feeVal = 0;
    if (pUnits && cfg.fee) {
      feeVal = cfg.fee(pUnits);
      const label = elType.value === 'acclamation'
                    ? 'Acclamation Service Fee'
                    : 'Inspector Fee';
      if (feeVal) lines.push({ label, cost: feeVal });
    }

    const grand = lines.reduce((s, l) => s + l.cost, 0);
    outT.textContent = `$${grand.toFixed(2)}`;
    outB.innerHTML   = lines
      .map(l => `<li>${l.label}: <strong>$${l.cost.toFixed(2)}</strong></li>`)
      .join('');

    showMarketingNote(eUnits, pUnits);
    showNoElectronicNote(eUnits);
  };

  ['input','change'].forEach(evt =>
    document.getElementById('cost-form').addEventListener(evt, recalc)
  );
  recalc();
});
